import { use$ } from "@legendapp/state/react"
import { syncStore$ } from "@/stores/sync.v2.store"
import { useMemo } from "react"

export function useModelUser() {
  const email = use$(syncStore$.userStatus.email)
  const domain = useMemo(() => {
    const domainPart = email ? email.substring(email.indexOf("@")) : "@example.com"
    return domainPart
  }, [email])
  const isAdmin = use$(syncStore$.userStatus.isAdmin)
  const canAccessMonitor = use$(syncStore$.userStatus.canAccessMonitor)
  const hasMonitorAccess = useMemo(() => {
    return isAdmin || canAccessMonitor
  }, [isAdmin, canAccessMonitor])

  return { email, domain, isAdmin, hasMonitorAccess }
}
